import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { createUUID } from '@shared/constants/Keys';
import { locales } from '@shared/constants/localization/LocalizationConstants';
import { useLocaleDisplayName } from '@shared/hooks/useLocaleDisplayName';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { LocalizationModelKeys } from '@shared/models/localization/Locales';
import { useTranslation } from 'react-i18next';

interface ILanguageFieldProps extends IControlFieldProps {
    variant: LocalizationModelKeys;
}

function LocalizationLanguageField({ value, onChange, disabled, variant }: ILanguageFieldProps) {
    const { t } = useTranslation();
    const fieldId = createUUID();
    const inputLabel = t(`common:localization.${variant}.title`);
    const getLocaleDisplayName = useLocaleDisplayName();

    return (
        <FormControl fullWidth>
            <InputLabel id={fieldId}>{inputLabel}</InputLabel>
            <Select
                labelId={`${variant}_language_field`}
                value={value}
                label={inputLabel}
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}>
                {locales[variant].map((locale) => (
                    <MenuItem key={`${locale}_${variant}`} value={locale}>
                        {getLocaleDisplayName(locale)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default LocalizationLanguageField;
